"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_HellScorned_OnTickEventHandlerScript = void 0;
const AbilityDamage_1 = require("../../core/AbilityDamage");
const DelayedDamage_1 = require("../../core/DelayedDamage");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
let Effect_HellScorned_OnTickEventHandlerScript = class Effect_HellScorned_OnTickEventHandlerScript {
    run(sequence, container, handler, event) {
        const remainingEmissions = handler.schedule.maxEmissions - handler.schedule.emissionCount;
        if (remainingEmissions >= 1) {
            container.applyDoTDamageV2({
                sequence,
                attackerId: handler.args.scriptArgs.attackerId,
                targetId: event.subject,
                damage: DelayedDamage_1.DelayedDamage.Focus("Burning", "Fire", 25)
            });
        }
        if (remainingEmissions > 1) {
            return;
        }
        else if (remainingEmissions === 1) {
            container.applyFloatingText(sequence, event.subject, `I'm on fire...`, "red", "large");
            return;
        }
        container.selectLivingTargets(event.subject, Target_1.Target.AllAllies)
            .forEach(targetId => {
            sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(targetId, "feet"), "DragonfirePillar"));
            container.applyAttackDamages({
                attackType: "magic_tick",
                attackerId: handler.args.scriptArgs.attackerId,
                targetId,
                isCrit: false,
                toApply: [
                    AbilityDamage_1.AbilityDamage.Focus("Fire", 100)
                ],
                sequence
            });
        });
    }
};
Effect_HellScorned_OnTickEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_HellScorned_OnTick")
], Effect_HellScorned_OnTickEventHandlerScript);
exports.Effect_HellScorned_OnTickEventHandlerScript = Effect_HellScorned_OnTickEventHandlerScript;
